import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  InputSignalWithTransform,
  numberAttribute,
  Signal,
} from '@angular/core';

import { SkeletonTextComponent } from '../skeleton-text/skeleton-text.component';

@Component({
  selector: 'lyceo-progress-bar',
  imports: [SkeletonTextComponent],
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  public readonly showText: InputSignal<boolean> = input<boolean>(true);
  public readonly loading: InputSignal<boolean> = input<boolean>(false);
  public readonly total: InputSignalWithTransform<number, unknown> = input<
    number,
    unknown
  >(0, { transform: (value) => numberAttribute(value, 0) });
  public readonly progress: InputSignalWithTransform<number, unknown> = input<
    number,
    unknown
  >(0, { transform: (value) => numberAttribute(value, 0) });

  protected readonly width: Signal<string> = computed(
    () => (this.progress() / this.total()) * 100 + '%',
  );
}
